//Imports
import React, { useContext, useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
//Imports Contexts
import { AppContext } from '../../contexts/AppContext';
//Import Helpers
import { formatDisplayName } from '../../shared/helpers';
//Imports Icons
import establishmentLogo from '../../assets/icons/establishmentLogo.svg';
//Import CSS
import './projectView.css';

function ProjectView() {
    const { establishmentList, usersList, dataProjects } = useContext(AppContext);
    const [selectDepartment, setSelectDepartment] = useState(null);
    const [project, setProject] = useState([]);
    const [filteredEstablishments, setFilteredEstablishments] = useState([]);
    const [usersByDepartment, setUsersByDepartment] = useState([]);
    const [isActive, setIsActive] = useState(false);
    const { id } = useParams();

    useEffect(() => {
        if (establishmentList && dataProjects) {
            const establishmentsFilteredById = establishmentList.filter(establishment => establishment.projectId === id);
            const projectFilteredById = dataProjects.find(project => project.id === id);
            setFilteredEstablishments(establishmentsFilteredById);
            setProject(projectFilteredById);
        }
    }, [establishmentList, dataProjects, id]);

    useEffect(() => {
        if (selectDepartment) {
            const filteredUsers = usersList
                .filter(user => user.tenantId === id)
                .filter(user => user.department === selectDepartment);
            setUsersByDepartment(filteredUsers);
        }
    }, [selectDepartment, usersList, id]);

    const isProjectActive = (project) => {
        if (!project || !project.contractValidity || !Array.isArray(project.contractValidity) || project.contractValidity.length === 0) {
            return false;
        }

        const { dateFrom, dateUntil } = project.contractValidity[0];

        if (!dateFrom || !dateUntil) {
            return false;
        }

        const currentDate = new Date();
        const startDate = new Date(dateFrom);
        const endDate = new Date(dateUntil);
        return currentDate >= startDate && currentDate <= endDate;
    }

    useEffect(() => {
        if (project && project.contractValidity) {
            const active = isProjectActive(project);
            setIsActive(active);
        }
    }, [project]);

    const handleDepartmentClick = (department) => {
        setSelectDepartment(department);
    };

    const searchDirector = (projectId, establishmentName) => {
        const directorRegex = /^Director(a)?$/i;
        const director = usersList.find(user =>
            user.tenantId === projectId &&
            user.establishment === establishmentName &&
            directorRegex.test(user.department)
        );
        return director ? director.displayName : 'No existe Director';
    }

    return (
        <section className='container-project-view flex'>
            <article className='box-project-info flex'>
                <article className='project flex'>
                    <span className='box-tittle'>
                        <aside className='box-logo flex'>
                            <img src={establishmentLogo} className='icon' alt='Logo de establecimiento' />
                        </aside>
                        <h1>{project?.nameProject}</h1>
                    </span>
                    <span className='project-status flex'>
                        <div className={`color ${isActive ? 'active' : 'inactive'}`}></div>
                        <p>{isActive ? 'Proyecto Activo' : 'Proyecto Inactivo'}</p>
                    </span>
                </article>
                <Link to='/proyectos' className='back-button flex'>Volver</Link>
            </article>
            <article className='box-project-details flex'>
                <article className='box box-departments flex'>
                    <h3>Departamentos</h3>
                    <article className='box-departments flex'>
                        {[
                            { name: "Departamento SEP", class: "sep" },
                            { name: "Departamento UTP", class: "utp" },
                            { name: "Departamento de Finanzas", class: "finance" },
                            { name: "Departamento de Adquisiciones", class: "adquisitions" },
                            { name: "Departamento Jurídico", class: "legal" },
                            { name: "Departamento de Control Interno", class: "internal-control" },
                            { name: "Departamento de Tesorería", class: "treasury" },
                        ].map((dept) => (
                            <div
                                key={dept.name}
                                className={`department ${dept.class} flex ${selectDepartment === dept.name ? "selected" : ""}`}
                                onClick={() => handleDepartmentClick(dept.name)}
                            >
                                <p>{dept.name}</p>
                            </div>
                        ))}
                    </article>
                </article>
                <article className='box box-users flex'>
                    <h3>Usuarios</h3>
                    <article className='box-results flex'>
                        {selectDepartment ? ((usersByDepartment.length > 0)
                            ? (usersByDepartment.map((user, index) => (
                                <div key={index}>
                                    <p><strong>{formatDisplayName(user.displayName)}</strong></p>
                                    <p>{user.email}</p>
                                </div>
                            ))
                            ) : (<p>No existen usuarios creados</p>)
                        ) : (
                            <p>Selecciona un departamento para ver los usuarios</p>
                        )
                        }
                    </article>
                </article>
                <article className='box box-establishments flex'>
                    <h3>Establecimientos a cargo</h3>
                    <article className='box-results flex'>
                        {filteredEstablishments.map((establishment) => (
                            <div className='establishment flex' key={establishment.id}>
                                <p>{establishment.nameEstablishment}</p>
                                <p>{searchDirector(establishment.projectId, establishment.nameEstablishment)}</p>
                            </div>
                        ))}
                    </article>
                </article>
            </article>
        </section>
    )
}

export default ProjectView;